import { Link } from "react-router";
import IconImg from "@components/Icon/IconImg";
import { NotificationDefaultProps } from "@features/notifications/NotificationToasts/utils/types";

/**
 * Renders a clickable notification toast display text and icon (if applicable).
 */
export default function NotificationWithRedirection({
  text,
  link,
  callback,
  icon,
}: NotificationDefaultProps): React.ReactElement {
  return (
    <Link
      to={link}
      target="_blank"
      className="flex w-full items-center justify-between"
      onClick={callback}
      data-testid="notification-with-redirection-component"
    >
      <p className="mb-0 items-center justify-center py-5 text-center font-poppins text-xs font-semibold">
        {text}
      </p>

      {icon ? (
        <IconImg
          icon={icon}
          imgAlt="notification icon"
          iconSize={24}
          className="ml-2 cursor-pointer"
        />
      ) : null}
    </Link>
  );
}
